import { ArrowRight } from "lucide-react";
import { Seo } from "@/components/Seo";
import { SocialLinks, useSettings } from "@/context/SettingsContext";
import { Brush } from "@/components/brand/Lettering";
import { Reveal } from "@/components/Reveal";
import { useEffect, useState } from "react";
import { ShoppingBag } from "lucide-react";
import { LookLightbox } from "@/components/LookLightbox";
import { getLookbook } from "@/lib/api";
import { LOOKS, breadcrumb } from "@/lib/site";

export default function Lookbook() {
  const { instagram } = useSettings();
  const [looks, setLooks] = useState(LOOKS.map((l, i) => ({ ...l, id: String(i), tags: [] })));
  const [open, setOpen] = useState(null);
  useEffect(() => { getLookbook().then((r) => r.length && setLooks(r)).catch(() => {}); }, []);
  return (
    <div data-testid="lookbook-page">
      <Seo title="Lookbook: Real people. Sus fits." description="Editorial street photography from Toronto featuring the suspects tees, hoodies, caps and accessories. Real people, sus fits." path="/lookbook" image="/img/look_6.webp" jsonLd={[breadcrumb([{ name: "Home", path: "/" }, { name: "Lookbook", path: "/lookbook" }])]} />
      <div className="mx-auto max-w-[1440px] px-5 pb-24 sm:px-10">
        <header className="flex flex-col gap-6 pb-14 pt-16 sm:flex-row sm:items-end sm:justify-between lg:pt-24">
          <div className="relative">
            <h1 className="display text-[clamp(4.5rem,13vw,11rem)]">Lookbook</h1>
            <Brush lines={["Real people.", "Sus fits."]} className="mt-4 text-3xl sm:absolute sm:-right-4 sm:-top-4 sm:mt-0 sm:translate-x-full sm:text-4xl" />
          </div>
          <p className="label text-ink/55 sm:text-right">Vol. 01<br />Toronto, Canada</p>
        </header>
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3" data-testid="lookbook-grid">
          {looks.map((l, i) => (
            <Reveal key={l.id} as="figure" delay={(i % 3) * 80} className="group">
              <button onClick={() => setOpen(l)} className="relative block w-full overflow-hidden rounded-[20px] text-left" aria-label={`Shop the look: ${l.caption}`} data-testid={`lookbook-photo-${i}`}>
                {l.tags.length > 0 && <span className="label absolute bottom-3 left-3 z-10 flex items-center gap-1.5 rounded-full bg-cloud/90 px-3 py-1.5 font-bold"><ShoppingBag size={12} /> Shop {l.tags.length}</span>}
                <img src={l.src} alt={l.alt} loading={i < 3 ? "eager" : "lazy"} className="photo aspect-[3/4] w-full object-cover transition-transform duration-1000 group-hover:scale-[1.03]" /></button>
              <figcaption className="label mt-3 flex justify-between text-ink/55"><span>{l.caption}</span><span>0{i + 1}</span></figcaption>
            </Reveal>
          ))}
        </div>
      </div>
      <LookLightbox look={open} onClose={() => setOpen(null)} />
      <section className="bg-lime" aria-labelledby="tag-title" data-testid="tag-us-banner">
        <div className="mx-auto flex max-w-[1440px] flex-col items-start gap-6 px-5 py-12 sm:px-10 md:flex-row md:items-center md:justify-between">
          <h2 id="tag-title" className="display text-[clamp(2.5rem,5vw,4.5rem)]">Tag us @thesuspects</h2>
          <div className="flex items-center gap-6">
            <SocialLinks prefix="lookbook-social" linkClass="text-ink hover:opacity-60" />
            {instagram && <a href={instagram} target="_blank" rel="noreferrer" className="btn btn-ink" data-testid="lookbook-instagram-link">Be a suspect <ArrowRight size={16} /></a>}
          </div>
        </div>
      </section>
    </div>
  );
}
